import { Avatar, Flex } from "@/atoms"
import { ImageIcon } from "@/icons"
import { UserItem } from "@/molecules/UserItem"
import { UserCell } from "./UserCell"

import styles from "../HeaderScanHistoryTab.module.scss"

import type { getTopInitiatorsByPolicyNameSelector } from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"

export const Initiator = (
  name: string,
  record: ReturnType<
    typeof getTopInitiatorsByPolicyNameSelector
  >["data"][number]
) => {
  if (record.scanner !== "CI") return UserCell(name)

  return (
    <Flex align="center">
      <Avatar size="small">
        <ImageIcon
          hideTooltip
          imageSource="local"
          className={styles.iconNoPolicy}
        />
      </Avatar>
      <UserItem initials="" email={name} />
    </Flex>
  )
}
